import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-kyc-expired-dialog',
  templateUrl: './kyc-expired-dialog.component.html',
  styleUrls: ['./kyc-expired-dialog.component.css']
})
export class KycExpiredDialogComponent {
  constructor(
    private matDialog: MatDialog,
    private router: Router,
    public languageService: LanguageService,
  ) { }
  close() {
    this.matDialog.closeAll();
  }
  goToKyc() {
    this.close();
    this.router.navigate(['/kyc/kyc-questions']);
  }
}
